import { useMemo } from 'react';

const useResultsTableSelection = ({ table, rowSelection }) => {
  return useMemo(() => {
    // Depend on selection state for recomputation when the user selects/deselects rows.
    void rowSelection;
    const selected = table.getSelectedRowModel?.().flatRows || [];
    return selected.map((item) => item.original).filter(Boolean);
  }, [table, rowSelection]);
};

export default useResultsTableSelection;
